import { Auth, Cache } from 'aws-amplify';
import axios from 'axios';
import config from 'configs';

export const getHeaderAuthorization = async () => {
  const federatedInfo = Cache.getItem('federatedInfo');

  if (federatedInfo) return {
    authorization: federatedInfo.token,
    provider: federatedInfo.provider
  }

  const { idToken } = (await Auth.currentSession()) || { idToken: {} };

  return {
    provider: 'CognitoUserPool',
    authorization: idToken.jwtToken
  };
}

export const linkProvider = (headers, callback) => {
  return axios({
    method: 'post',
    baseURL: config.api.API.BASE,
    url: config.api.API.LINK_PROVIDER,
    headers: headers
  }).then(res => {
    return callback();
  }).catch(er => {
    return callback(er);
  });
};